import React from 'react';
import { Button, Modal, Form, Input, TooltipHelp, Dropdown, ToastContext } from '@weezevent/nacre';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { requiredField, useForm } from '../../../utils/validators';
import DiscountCodeModel from '../../../models/discountCodeModel';
import { useSegment } from '../../../components/tracking/trackingProvider';
export function DuplicateAction({ organization, event, discount_code, sync }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const toast = React.useContext(ToastContext);

    const { track } = useSegment();
    const [discountForm, setDiscount, setDiscountObject, discountErrors, dicountValidate] = useForm(
        {
            name: discount_code.discount.name && `${discount_code.discount.name} - ${t('ticket.common.copy')}`,
            code: ''
        },
        {
            code: requiredField
        }
    );
    React.useEffect(() => {
        dicountValidate();
    }, [discountForm]);

    const duplicate = () => {
        setIsSubmitting(true);
        let newDiscount = new DiscountCodeModel({ ...discount_code, ...discount_code.discount });
        newDiscount.name = discountForm.name || null;
        newDiscount.code = discountForm.code;
        if (newDiscount.discount_type !== 'grid') {
            newDiscount.value = newDiscount.discount_type === 'amount' ? newDiscount.discount_rules[0].amount : newDiscount.discount_rules[0].percentage;
        }

        const rates = newDiscount.discount_rules
            .map(
                ({ rate, amount }) =>
                    rate && {
                        rate,
                        value: Number(amount)
                    }
            )
            .filter(rule => rule);
        if (rates.length) {
            newDiscount.rates = rates;
        }

        newDiscount.event = event.id;

        delete newDiscount.id;
        delete newDiscount.discount;
        delete newDiscount.discount_rules;
        delete newDiscount.created;
        delete newDiscount.enabled;
        delete newDiscount.status;
        delete newDiscount.usage;

        newDiscount
            .save({ organizationId: organization.pk, eventId: event.id, isCreateOrUpdate: true })
            .then(() => {
                setIsOpen(false);
                setDiscountObject({});
                toast.success(t(`ticket.discountForm.duplicate.success`));
                sync();
            })
            .catch(e => {
                setIsOpen(false);
                toast.error(t(`ticket.discountForm.duplicate.error`));
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div onClick={e => e.stopPropagation()}>
            <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                size="large"
                title={t('ticket.discountForm.duplicate.modal.title', { discount_code: discount_code.code })}
                subtitle={t('ticket.discountForm.duplicate.modal.subtitle')}
                submitButton={
                    <Button primary isLoading={isSubmitting} onClick={duplicate} label={t('ticket.common.action.save')} disabled={Object.entries(discountErrors).length > 0} />
                }
                cancelButton={<Button onClick={() => setIsOpen(false)} label={t('ticket.common.action.cancel')} />}
            >
                <Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Form.Label className="" label={t('ticket.discountForm.duplicate.code')} optionalText={null} required={false} />
                        <TooltipHelp position="bottom" triggerOnHover title={t('ticket.discountForm.duplicate.tooltip_code')} />
                    </div>
                    <Input
                        value={discountForm.code}
                        onChange={({ target: { value } }) => {
                            setDiscount('code', value);
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Form.Label className="" label={t('ticket.discountForm.duplicate.name')} optionalText={t('ticket.common.labelOptional')} required={false} />
                        <TooltipHelp position="bottom" triggerOnHover title={t('ticket.discountForm.duplicate.tooltip_name')} />
                    </div>
                    <Input
                        value={discountForm.name}
                        onChange={({ target: { value } }) => {
                            setDiscount('name', value);
                        }}
                    />
                </Form.Field>
            </Modal>
            <Dropdown.Item
                onClick={() => {
                    track('ACTION > DUPLICATE DISCOUNT', { 'Page Title': 'DISCOUNTS', Application: 'WeezTicket nBO' });
                    setIsOpen(true);
                }}
            >
                {t('ticket.common.action.duplicate')}
            </Dropdown.Item>
        </div>
    );
}

DuplicateAction.propTypes = {
    event: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    discount_code: PropTypes.object.isRequired,
    sync: PropTypes.func.isRequired
};
